import { SiglaDeGrauMacon, converterGrauMaconParaSigla, TotaisPorGrau } from './../../common/shareds/sharedsIrmao'
import { GrauMacon } from 'common/types/Irmao'

export interface TotalDeGrau {
	sigla: SiglaDeGrauMacon
	grau: GrauMacon
	valor: number
}

export function totaisPorGrauOrdenados(totais: TotaisPorGrau | {} = {}): TotalDeGrau[] {
	return ([
		'Mestre Instalado',
		'Mestre',
		'Companheiro',
		'Aprendiz',
	] as GrauMacon[]).map(grau => ({
		sigla: converterGrauMaconParaSigla(grau),
		grau,
		valor: grau in totais ? (totais as TotaisPorGrau)[grau] : 0,
	}))
}

export async function delay(ms = 500) {
	return new Promise(resolve => {
		setTimeout(() => resolve(undefined), ms)
	})
}

export function extrairMesEAno(date: string) {
	return date.split('-').slice(0, 2).join('-')
}
